import React from 'react';
import type { Step } from '../../types/content';
interface StepListProps {
  items: Step[];
}
export function StepList({
  items
}: StepListProps) {
  const cols = items.length >= 5 ? 'lg:grid-cols-5' : items.length === 4 ? 'lg:grid-cols-4' : 'lg:grid-cols-3';
  return <ol className={`relative grid gap-5 md:grid-cols-2 ${cols}`} data-id="element-854" data-mp="1cmscbrcfjn40">
      <span className="pointer-events-none absolute left-8 right-8 top-[44px] hidden border-t-2 border-dashed border-line lg:block" aria-hidden="true" data-id="element-855" data-mp="1co3h9uhm30wp" />
      {items.map((step, index) => {
      const last = index === items.length - 1;
      return <li key={step.title} className="relative flex flex-col" data-id="element-856" data-mp="1rjt6s2m09w66" data-mpi={index}>
            <span className={`relative z-10 flex h-[60px] w-[60px] items-center justify-center rounded-[15px] type-h3 ${last ? 'bg-brand text-white' : 'border-2 border-ink bg-white text-ink'}`} aria-hidden="true" data-id="element-857" data-mp="1vlo6x3s7a3id">
              {index + 1}
            </span>
            <div className="mt-6 flex-1 rounded-[24px] bg-mist p-6" data-id="element-858" data-mp="36j3pg0ssvtof">
              <h3 className="type-h3 text-ink" data-id="element-859" data-mp="31s59517tavl6">
                <span className="sr-only" data-id="element-860" data-mp="31rdcdn2hartb">Step {index + 1}: </span>
                {step.title}
              </h3>
              <p className="mt-3 type-card-desc" data-id="element-861" data-mp="2wtk8x1sk8bwq">{step.text}</p>
            </div>
          </li>;
    })}
    </ol>;
}